
// HomeSection.jsx
import "../styles/HomeSection.css";
import heroImage from "../assets/shield.png"; // replace with your image

export default function HomeSection() {

  // ⚡ Define the function inside the component
  const handleStartClick = () => {
    const uploadSection = document.getElementById("upload");
    if (uploadSection) {
      uploadSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="home" className="home-section">
      <div className="home-left">
        <h1>Malware Detection & Analysis</h1>
        <p>
          Protect your system with intelligent malware detection using
          advanced machine learning algorithms. Upload your files and get
          instant results.
        </p>
        {/* Start button */}
        <button className="home-start-btn" onClick={handleStartClick}>
          Start
        </button>
      </div>

      <div className="home-right">
        <img src={heroImage} alt="Malware Detection Hero" />
      </div>
    </section>
  );
}